import * as React from 'react'

export default props => {
  const { active } = props
  return (
    <svg
      width={24}
      height={25}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.672c-4.707 0-8.536 3.84-8.536 8.56 0 4.719 3.83 8.558 8.537 8.558 4.707 0 8.536-3.84 8.536-8.559 0-4.72-3.83-8.559-8.536-8.559Zm0 18.585c-5.514 0-10-4.497-10-10.026C2 6.703 6.486 2.205 12 2.205s10 4.498 10 10.026c0 5.529-4.486 10.026-10 10.026Z"
        fill="#00112B"
      />
      {active && <circle cx={12} cy={12.199} r={5} fill="#004360" />}
    </svg>
  )
}
